import { inject, Injectable, Injector } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { Router } from "@angular/router";
import { environment } from 'src/environments/environment';
import { BaseService } from './base.service';
declare var window;
@Injectable({
    providedIn: 'root'
})
//We are using localstorage here, not storage service.
export class AppService {

    public _appName: string = null;
    public _curApp: string = null;
    public _currentSessionData: any = {};
    public printEngineTemplate = [];
    public _factories: any = {};
    public _currentData: any = {};
    public printTemplateSettings: any = [];
    public _currentKeys: any = {};
    public _appData = null;
    public _applications = null;
    public _permissions: any = null;
    public _dashBoardOpened: boolean = true;
    public _initialRouteConfig: any = false;
    public showSidebar = false;
    public _iskiosk = false;
    public _face_recognition = false;
    public bot_id: any = null;

    public _widgets = {
        "main": [
            'widget_ip',
            'widget_bedstatus',
            'widget_chart',
            'widget_bedchart',
            'widget_allpatient',
            'widget_admissionType',
            'widget_reg',
            'widget_allvisits',
            'widget_ipchart',
            'widget_wardwisepatient',
        ]
    };
    public _default_user_data: any = {
        data_format: "DD/MM/YYYY",
        locale: 'en-US',
        time_format: 'hh:mm:ss A',
        timezone: 'Asia/Kolkata',
        dateTime_format: 'DD/MM/YYYY hh:mm a',
        monthYear_format: 'MM/YYYY'
    };

    constructor(
        public Router: Router,
        private injector: Injector,
    ) {
        this._factories["modules"] = {};
        this._factories["components"] = {};
        this.initData();
    }

    initData() {
        var header: any = false;
        var superApps: any = false;
        var streamsaver: any = false;
        if (this._currentSessionData != undefined && this._currentSessionData.header != undefined) {
            header = this._currentSessionData.header;
        }
        if (this._currentSessionData != undefined && this._currentSessionData.streamsaver != undefined) {
            streamsaver = this._currentSessionData.streamsaver;
        }
        if (this._currentSessionData != undefined && this._currentSessionData.superApps != undefined) {
            superApps = this._currentSessionData.superApps;
        }
        var defaultApp = this.getDefaultApp();
        this._currentKeys.appKey = 'CURRENT_APPLICATION';
        this._currentKeys.orgKey = 'CURRENT_ORGANIZATION';
        this._currentKeys.curApp = 'CURRENT_APP';
        this._currentKeys.currentUserKey = 'currentUser';
        this._currentKeys.roleKey = 'CURRENT_ROLE';
        this._currentKeys.selectedLocation = 'CURRENT_LOCATION';
        this._currentKeys.currency = 'CURRENCY';
        this._currentKeys.adConfigs = 'ADCONFIGS';
        this._currentKeys.authenticationType = 'AUTHENTICATION_TYPE';
        this._currentSessionData = {};
        this._currentSessionData.nav_id = [];
        this._currentSessionData.menuList = [];
        this._currentSessionData.origMenuList = [];
        this._currentSessionData.mobileMenu = [];
        this._currentSessionData.hideMenuIcon = false;
        this._currentSessionData.debuggingMode = false;
        this._currentSessionData.dynamicJsonList = [];
        this._currentSessionData.dynamicJson = {};
        this._currentSessionData.noCodeJsonList = [];
        this._currentSessionData.noCodeJson = {};
        this._currentSessionData.accountConfig = {};
        this._currentSessionData.accountConfigValue = {};
        this._currentSessionData.archiveCatalogueList = {};
        this._currentSessionData.currency = [];
        this._currentSessionData.face_recognition = false;
        this._currentSessionData.whiteListedUrls = {};
        this._currentSessionData.defaultApp = defaultApp;
        this._currentSessionData.qrLoginPassed = "";
        this._currentSessionData.showqrLogin = false;
        this._currentSessionData.showAccountWebsite = true;
        this._currentSessionData.accountWebsiteLabel = "Visit Website";
        this._currentSessionData.streamsaver = "default";
        if (header) {
            this._currentSessionData.header = header;
        }
        if (superApps) {
            this._currentSessionData.superApps = superApps;
        }
        if (streamsaver) {
            this._currentSessionData.streamsaver = streamsaver;
        }
    }

    setUpLanguageMap(ln, m) {
        if (this._appData.language_json == undefined) {
            this._appData.language_json = {};
            this._appData.language_json[ln] = m;
        } else {
            this._appData.language_json[ln] = { ...this._appData.language_json[ln], ...m };
        }
    }

    setArchiveCatalagueList(key, list) {
        this._currentSessionData.archiveCatalogueList[key] = list;
    }
    checkArchiveCatalagueExists(key) {
        return (this._currentSessionData.archiveCatalogueList[key] != undefined);
    }
    getArchiveCatalague(key) {
        return this._currentSessionData.archiveCatalogueList[key];
    }
    //this maintains the files which are loaded for the launguage translation
    setLaungFileCheckList(fileName) {
        if (this._appData.LaungFileCheckList == undefined) {
            this._appData.LaungFileCheckList = [];
            this._appData.LaungFileCheckList.push(fileName);
        } else if (!this._appData.LaungFileCheckList.includes(fileName)) {
            this._appData.LaungFileCheckList.push(fileName);
        }

    }

    //imports the language file
    async launguageSetup(application, ln, callback) {
        var base_ln;
        var local_ln_exist = ln.includes('-');
        if (local_ln_exist) base_ln = ln.split('-')[0]
        else base_ln = ln;
        return await import('src/assets/translations/' + application + '/' + base_ln + '.resource.json').then(m => {
            this.setUpLanguageMap(ln, m);
            this.setLaungFileCheckList(application + base_ln + '.resource.json');//maintains the checklist for loaded files

        })
            .then(async () => {
                if (local_ln_exist)
                    await this.loadLocalLanguageFile(application, ln, callback);
            })
            .then(() => {
                callback(true);
            })
            .catch((err) => {
                callback(true);
                //console.warn('translation file not found for module ' + application, err)
            });
    }

    async loadRootLocalLanguageFile(ln, callback) {
        return await import('src/assets/translations/' + ln + '.resource.json').then(m => {
            console.log('root Local resource');
            this.setUpLocalLanguageMap(ln, m);
        })
            .catch((err) => {
                callback(false);
            });
    }

    async loadLocalLanguageFile(application, ln, callback) {
        return await import('src/assets/translations/' + ln + '.resource.json').then(m => {
            console.log('application Local resource');
            this.setUpLocalLanguageMap(ln, m);
        })
            .catch((err) => {
                callback(false);
            });
    }

    setUpLocalLanguageMap(ln, m) {
        if (this._appData.language_json == undefined) {
            this._appData.language_json = {};
            this._appData.language_json[ln] = m;
        } else {
            let new_lan_obj = Object.assign({}, this._appData.language_json[ln], m.default);
            this._appData.language_json[ln] = new_lan_obj
        }
    }

    init(data): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            this.setAppData(data);
            this.initDynamicFuntions(data);
            resolve(true);
        });

        return promise;
    }

    setAppData(data) {
        this._appData = data;
    }

    getAppData() {
        if (this._appData) {
            return this._appData;
        } else {
            return {};
        }
    }


    setApplication(app) {
        this._appName = app;
        sessionStorage.setItem(this._currentKeys.appKey, app);
    }

    getApplication() {
        if (this._appName) {
            return this._appName;
        }
        this._appName = sessionStorage.getItem(this._currentKeys.appKey);
        if (this._appName == "") {
            this._appName = this._appData.DEFAULT_APPLICATION;
        }
        return this._appName;
    }

    setApp(app) {
        this._curApp = app;
        localStorage.setItem(this._currentKeys.curApp, app);
    }

    getApp() {
        if (this._curApp) {
            return this._curApp;
        }
        this._curApp = localStorage.getItem(this._currentKeys.curApp);
        if (this._curApp == "") {
            this._curApp = this._appData.DEFAULT_APP;
        }
        return this._curApp;
    }

    setOrganization(app) {
        this._currentSessionData.orgObj = app;
        localStorage.setItem(this._currentKeys.orgKey, JSON.stringify(app));
    }

    setRole(app) {
        this._currentSessionData.roleObj = app;
        localStorage.setItem(this._currentKeys.roleKey, JSON.stringify(app));
    }

    // setCurrency(_currency) {
    //     this._currentSessionData.currency = _currency;
    //     localStorage.setItem(this._currentKeys.currency, JSON.stringify(_currency));
    // }

    isFacilityAware() {
        return (this._currentSessionData.facility_args_required != undefined) ? this._currentSessionData.facility_args_required : false;
    }
    isLocationAware() {
        return (this._currentSessionData.location_args_required != undefined) ? this._currentSessionData.location_args_required : false;
    }

    getCurrency(facility_id: any) {
        if (this._currentSessionData["currencyAccount"] != undefined) {
            return this._currentSessionData["currencyAccount"];
        } else {
            return "";

        }
        //removed currency because currency is moved to account level
        // if (!this.isFacilityAware()) {
        //     return (this._currentSessionData.currency != undefined && this._currentSessionData.currency.find(x => x.org_id == this.getOrganization().org_id) && this._currentSessionData.currency.find(x => x.org_id == this.getOrganization().org_id).currency) ? this._currentSessionData.currency.find(x => x.org_id == this.getOrganization().org_id).currency : "";
        // } else {
        //     return (this._currentSessionData.currency != undefined && this._currentSessionData.currency.find(x => x.org_id == facility_id) && this._currentSessionData.currency.find(x => x.org_id == facility_id).currency) ? this._currentSessionData.currency.find(x => x.org_id == facility_id).currency : "";
        // }
    }

    isCSPAccount() {
        return (this._currentSessionData.is_csp_request != undefined) ? this._currentSessionData.is_csp_request : false;
    }
    printWithoutHF() {
        return (this._currentSessionData.print_without_h_f != undefined) ? this._currentSessionData.print_without_h_f : true;
    }

    enablefacerecognition() {
        return (this._currentSessionData.face_recognition != undefined) ? this._currentSessionData.face_recognition : true;
    }

    setLocation(app) {
        this._currentSessionData.locationObj = app;
    }

    setLocationAwareConfig(location) {
        this._currentSessionData.jsonLocationAware = location;
    }

    setCurrentLocation(app) {
        this._currentSessionData.selectedLocation = app;
        localStorage.setItem(this._currentKeys.selectedLocation, JSON.stringify(app));
    }

    deleteLocation() {
        delete this._currentSessionData.locationObj;
        delete this._currentSessionData.selectedLocation;
        localStorage.setItem("deletedLocation", "true");
        localStorage.removeItem(this._currentKeys.selectedLocation);
    }

    // getCurrentCareType() {
    //     return this.getUniversalConfig("care_type").length != 0 ? this.getUniversalConfig("care_type")[0].id : false
    // }
    getCurrentLocation() {
        if (this._currentSessionData.selectedLocation) {
            return this._currentSessionData.selectedLocation;
        }
        try {
            this._currentSessionData.selectedLocation = JSON.parse(localStorage.getItem(this._currentKeys.selectedLocation));
            return this._currentSessionData.selectedLocation;
        } catch (e) {
            return null;
        }
    }

    getLocation() {
        if (this._currentSessionData.locationObj) {
            return this._currentSessionData.locationObj;
        } else {
            return null;
        }
    }
    removeOrganization() {
        localStorage.removeItem(this._currentKeys.orgKey);
        this._currentSessionData.orgObj = null;
    }

    removeCurrentRole() {
        localStorage.removeItem(this._currentKeys.roleKey);
        this._currentSessionData.roleObj = null;
    }

    getOrganizationList() {
        return this._currentSessionData.orgList ?? [];
    }
    getOrganization() {
        if (this._currentSessionData.orgObj) {
            return this._currentSessionData.orgObj;
        }
        try {
            this._currentSessionData.orgObj = JSON.parse(localStorage.getItem(this._currentKeys.orgKey));
            return this._currentSessionData.orgObj;
        } catch (e) {
            return null;
        }
    }

    getOrgList() {
        return this.getOrganizationList() ? this.getOrganizationList().map(x => { return { org_id: x.org_id, org_name: x.org_name } }) : [];
    }

    getRoles() {
        if (this._currentSessionData.roleObj) {
            return this._currentSessionData.roleObj;
        }
        try {
            this._currentSessionData.roleObj = JSON.parse(localStorage.getItem(this._currentKeys.roleKey));
            return this._currentSessionData.roleObj;
        } catch (e) {
            return null;
        }
    }

    buildDynamicApp(router, paths, dynamic_application, AuthGuard) {
        for (let index = 0; index < dynamic_application.length; index++) {
            let singleApplication = dynamic_application[index];

            var obj = {
                path: singleApplication.name,
                canActivate: [AuthGuard],
                data: {
                    application: singleApplication.name,
                    defaultApplication: singleApplication.defaultApplication,
                    crudList: (singleApplication.crudList != undefined) ? singleApplication.crudList : [],
                    routeDef: (singleApplication.routeDef != undefined) ? singleApplication.routeDef : []
                },
                loadChildren: (this._appData.MODULE_DEF[singleApplication.name] != undefined) ? this._appData.MODULE_DEF[singleApplication.name]() : this._appData.MODULE_DEF['default']()
            }
            paths.splice((paths.length - 3), 0, obj);
        }
        router.resetConfig(paths);
    }

    buildNocodeApp(router, paths, nocode_application, AuthGuard) {
        for (let index = 0; index < nocode_application.length; index++) {
            let singleApplication = nocode_application[index];

            var obj = {
                path: singleApplication.name,
                canActivate: [AuthGuard],
                data: {
                    application: singleApplication.name,
                    defaultApplication: singleApplication.defaultApplication,
                    crudList: (singleApplication.crudList != undefined) ? singleApplication.crudList : [],
                    routeDef: (singleApplication.routeDef != undefined) ? singleApplication.routeDef : []
                },
                loadChildren: (this._appData.MODULE_DEF[singleApplication.name] != undefined) ? this._appData.MODULE_DEF[singleApplication.name]() : this._appData.MODULE_DEF['default']()
            }
            paths.splice((paths.length - 3), 0, obj);
        }
        router.resetConfig(paths);
    }

    setPartnerId(partnerId: string) {
        this._currentSessionData.partnerId = partnerId;
    }

    getPartnerId(): string {
        return this._currentSessionData.partnerId
    }

    setDistributorId(distributorId: string) {
        this._currentSessionData.distributorId = distributorId;
    }

    getDistributorId(): string {
        return this._currentSessionData.distributorId
    }

    getCurrentUser() {
        var getUser: any;
        //I have not used storage service here becuase it will break everywhere if we use callback 
        //and we are always going to use localstorage for session stroage
        //may be we should use cookie for session id
        getUser = localStorage.getItem(this._currentKeys.currentUserKey);
        try {
            getUser = JSON.parse(getUser)
            return getUser;
        } catch (e) {
            return '';
        };
    }
    getSessionId() {
        // if(this.getCurrentUser() && this.getCurrentUser().user_type=='kiosk_user'){
        //     return JSON.parse(localStorage.getItem("loggedin"))
        // }else{
        return this.readCookie("loggedin");
        // }
    }


    makePermissions() {
        if (!this._appData.RBACK_ENABLED) {
            return;
        }
        var tiles = this._applications;
        if (tiles) {
            this._permissions = {};
            for (let index = 0; index < tiles.length; index++) {
                var obj: any = tiles[index];
                this._permissions[obj.id] = obj.menu;
            }
        }
    }

    async nativeDataHandling(type, data) {
        if (this.checkNativeApp()) {
            try {
                var argsNative = { type: type, data: data };
                var response = await window.flutter_inappwebview.callHandler('pwaData', ...[argsNative]);
                return response;

            } catch (e) {
                console.error(e);
                return false;
            }
        } else {
            return false;
        }
    }

    logout(callback) {
        let langList = [];
        if (this._currentSessionData && this._currentSessionData.languageList) {
            langList = this._currentSessionData.languageList;
        }
        this.setApplication('');
        this._applications = null;
        this._permissions = null;
        this.initData();
        this.setLanguageList(langList);
        this.removeOrganization();
        this.delete_cookie("loggedin");
        if (this.checkNativeApp()) {
            this.nativeDataHandling("loggedout", {}).then(() => {
                callback()
            })
        } else {
            this.nativeDataHandling("loggedout", {}).then(() => {
                callback()
            })
        }


    }
    getApiEndpoint(api_str, application?: any) {
        if (application == undefined || application == '') {
            application = this.getApplication();
        }
        if (this.getAppData().APPLICATION_AWARE != undefined && this.getAppData().APPLICATION_AWARE) {
            return '/' + application + '/' + api_str + '/' + this.getAppData().API_VERSION + '/';
        } else {
            return '/' + api_str + '/' + this.getAppData().API_VERSION + '/';
        }
    }
    initDynamicFuntions(config) {
        if (config.CONFIG_FUNCTIONS != undefined && config.CONFIG_FUNCTIONS.length > 0) {
            this._appData["dynamiceFun"] = {};
            for (let index = 0; index < config.CONFIG_FUNCTIONS.length; index++) {
                var funVar = config.CONFIG_FUNCTIONS[index];
                if (funVar.fun != undefined && funVar.name != undefined) {
                    this._appData["dynamiceFun"][funVar.name] = new Function(...funVar.fun).bind(this)
                }
            }
        }
    }

    getDynamicFunctions(name, args = []) {
        if (this._appData.dynamiceFun[name] != undefined) {
            return this._appData.dynamiceFun[name].apply(this, args);
        } else {
            throw new Error("Function " + name + " doesn't exist");
        }
    }

    getCurrentAppObj(menuId) {
        var found = false;
        var menuList = this.getMenuList();
        if (menuList && menuList.length) {
            for (let singleMenu of menuList) {
                if (singleMenu.id == menuId) {
                    found = singleMenu;
                }
            }
        }
        return found;
    }

    // routeChanged(event: any) {
    //     console.log("event is :: ", event);
    // }



    getCurrentAddress() {
        //TODO by sauravdeep 
        return JSON.parse(localStorage.CURRENT_ORGANIZATION).primary_address
    }

    getCurrentFacilityID() {
        var curOrg = localStorage.CURRENT_ORGANIZATION;
        if (curOrg != null) {
            let obj = JSON.parse(localStorage.CURRENT_ORGANIZATION);
            if (obj.org_id != null) {
                return obj.org_id;
            }
        }
        return false;
    }


    getUniversalConfig(config) {
        return this._currentSessionData[config] == undefined ? false : this._currentSessionData[config]
    }

    setActiveParentMenuId(router) {
        var found = false;
        var emptied = false;
        var menuList = this.getMenuList()
        //this._currentSessionData.nav_id = [];
        if (menuList && menuList.length) {
            for (let singleMenu of menuList) {
                if (singleMenu.url != undefined && singleMenu.url && router.isActive(singleMenu.url, false)) {
                    this._currentSessionData.nav_id = [];
                    emptied = true;
                    break;
                }
                if (singleMenu.children != undefined && singleMenu.children.length > 0) {
                    for (let singleMenuChild of singleMenu.children) {
                        if (singleMenuChild.url != undefined && singleMenuChild.url && router.isActive(singleMenuChild.url, false)) {
                            if (!emptied) {
                                this._currentSessionData.nav_id = [];
                                emptied = true;
                            }
                            this._currentSessionData.nav_id.push(singleMenu.id);
                            found = true;
                            break;
                        }
                        if (singleMenuChild.children != undefined && singleMenuChild.children.length > 0) {
                            for (let singleMenuChildObj of singleMenuChild.children) {
                                if (singleMenuChildObj.url != undefined && singleMenuChildObj.url && router.isActive(singleMenuChildObj.url, false)) {
                                    if (!emptied) {
                                        this._currentSessionData.nav_id = [];
                                        emptied = true;
                                    }
                                    this._currentSessionData.nav_id.push(singleMenuChild.id);
                                    this._currentSessionData.nav_id.push(singleMenu.id);
                                    found = true;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    setAppHeader(header) {
        if (Object.keys(header).length) {
            for (let key in header) {
                //if any value is empty we will set it to default config value;
                if (header[key] == "" && this._appData.HEADER[key] != undefined) {
                    header[key] = this._appData.HEADER[key];
                }
            }
            this._currentSessionData.header = header;
        }
    }

    getAppHeader() {
        if (this._currentSessionData.header != undefined) {
            return this._currentSessionData.header;
        } else {
            return this._appData.HEADER;
        }
    }

    setStreamSaver(streamsaver) {
        if (streamsaver) {
            this._currentSessionData.streamsaver = streamsaver;
        } else {
            this._currentSessionData.streamsaver = "default";
        }
    }



    getStreamSaver() {
        if (this._currentSessionData.streamsaver != undefined) {
            return this._currentSessionData.streamsaver;
        } else {
            return "default";
        }
    }

    setEnv(env) {
        if (env) {
            this._currentSessionData.environment = env;
        }
    }

    getEnv() {
        if (this._currentSessionData.environment != undefined) {
            return this._currentSessionData.environment;
        } else {
            return "";
        }
    }

    setCareType(care_type: any) {
        this._currentSessionData.care_type = care_type
    }
    setAddress(addressForm, addressTemplate) {
        try {
            var newAddress = JSON.parse(addressForm);
        } catch (e) {
            return;
        }
        this._appData.JSON_DEF.address = newAddress
        this._appData.TEMPLATE_DEF.address = addressTemplate;

    }

    getUUID(user_id) {
        if (this._currentSessionData.encryptKey != undefined && this._currentSessionData.encryptKey) {
            var key = this._currentSessionData.encryptKey;
            return this.encryptText(key, user_id);
        }
        return false;
    }

    parseMyConfigObject(resource) {
        if (resource.applications != undefined) {
            resource.applications.forEach(element => {
                element.main = true;
            });
            this._applications = resource.applications;
            this.makePermissions();
        }
        this._currentSessionData.orgList = [];
        if (resource.facilities != undefined) {
            if (resource.facility_args_required) {

                if (this._currentSessionData.orgList.length > 0) {
                    this._currentSessionData.orgList = resource.facilities;
                    this._currentSessionData.orgList.unshift({ org_name: "All", org_id: "" })
                } else {
                    this._currentSessionData.orgList.push({ org_name: "All", org_id: "" })
                }
            } else {
                this._currentSessionData.orgList = resource.facilities;
                // this._currentSessionData.orgList.unshift({ org_name: "All", org_id: "" })
            }
        }

        if (resource.facility_args_required != undefined) {
            this._currentSessionData.facility_args_required = resource.facility_args_required
        }
        if (resource.location_args_required != undefined) {
            this._currentSessionData.location_args_required = resource.location_args_required
        }
        if (resource.is_csp_request != undefined) {
            this._currentSessionData.is_csp_request = resource.is_csp_request
        }
        if (resource.print_without_h_f != undefined) {
            this._currentSessionData.print_without_h_f = resource.print_without_h_f
        }
        if (resource.face_recognition != undefined) {
            this._currentSessionData.face_recognition = resource.face_recognition
        }
        if (resource.bot_id != undefined) {
            this._currentSessionData.bot_id = resource.bot_id
        }

        // Patient URL white list  
        if (resource.white_listed_urls != undefined && Array.isArray(resource.white_listed_urls) && resource.white_listed_urls.length > 0) {
            this.parseWhiteListedUrls(resource.white_listed_urls);
        }
        if (resource.print_engine != undefined) {
            this._currentSessionData.print_engine = resource.print_engine
        }

        this._currentSessionData.roleList = [];
        if (resource.user_roles != undefined) {
            this._currentSessionData.roleList = resource.user_roles;
        }

        this._currentSessionData.encryptKey = false;
        if (resource.extra_data && resource.extra_data.newres) {
            this._currentSessionData.encryptKey = resource.extra_data.newres;

            var encrypTed = localStorage.getItem("uuid");
            if (encrypTed != undefined) {
                var uuId = this.decryptText(this._currentSessionData.encryptKey, encrypTed);
                console.log("UUID", uuId);
                if (uuId != resource.user_id) {
                    console.error("user id not found");
                    this.logout(() => {
                        window.location.reload();
                    });
                }
            }

        }


        if (resource.header != undefined) {
            this.setAppHeader(resource.header);
        }
        if (resource.language != undefined) {
            this.setLanguageList(resource.language)
        }

        if (resource.address_form_template != undefined && resource.address_form_template != "" && resource.address_grid_template != undefined && resource.address_grid_template != "") {
            this.setAddress(resource.address_form_template, resource.address_grid_template);
        }

        if (resource.menus != undefined && resource.menus.length) {
            this.setMenuList(resource.menus);
            this._currentSessionData.origMenuList = JSON.parse(JSON.stringify(this._currentSessionData.menuList));
        }

        if (resource.landing_url != undefined && resource.landing_url) {
            this._currentSessionData.dashboardUrlFound = resource.landing_url;
            this._currentSessionData.device_type_id = resource.device_type_id;
            this._currentSessionData.device_type = resource.device_type;
            var user = this.getCurrentUser();
            this._currentSessionData.dashboardUrlFound = this.buildDyanamicStr(this._currentSessionData.dashboardUrlFound, user);
        }
        if (resource.location != undefined && resource.location.length) {
            this.setLocation(resource.location);
        }
        if (resource.testing_flag != undefined) {
            this._currentSessionData.debuggingMode = resource.testing_flag;
        }
        if (resource.dynamic_json != undefined && Array.isArray(resource.dynamic_json)) {
            this._currentSessionData.dynamicJsonList = resource.dynamic_json;
        }
        if (resource.nocode_json != undefined && Array.isArray(resource.nocode_json)) {
            this._currentSessionData.noCodeJsonList = resource.nocode_json;
        }

        // if (resource && resource.currency != undefined) {
        //     this.setCurrency(resource.currency);
        // }

        if (resource.device_authenticated != undefined) {
            this._currentSessionData.deviceAuthenticated = resource.device_authenticated;
        }

        if (resource.geofence_auth != undefined) {
            this._currentSessionData.qrLoginPassed = resource.geofence_auth;
        }

        if (resource.multi_care_type != undefined) {
            this._currentSessionData.multi_care_type = resource.multi_care_type
        }

        if (resource.care_type != undefined) {
            this.setCareType(resource.care_type)
        }
        if (resource.name != undefined) {
            this._currentSessionData.name = resource.name
        }

        if (resource.profile_id != undefined) {
            this._currentSessionData.profile_id = resource.profile_id
        }

        if (resource.prn_enabled != undefined) {
            this._currentSessionData.prn_enabled = resource.prn_enabled;
        }

        if (resource.view_only != undefined) {
            this._currentSessionData.view_only = resource.view_only;
        }

        if (resource.user_group != undefined) {
            this._currentSessionData.user_group = resource.user_group;
        }

        if (resource.current_app != undefined) {
            this.setApp(resource.current_app);
        }
        if (resource.currency_decimal_limit != undefined) {
            this._currentSessionData.currency_decimal_limit = resource.currency_decimal_limit;
        }

        if (resource.wcag_enabled != undefined) {
            this._currentSessionData.wcag_enabled = resource.wcag_enabled;
        }

        if (resource.is_kiosk != undefined) {
            this._iskiosk = resource.is_kiosk;
        }

        if (resource.face_recognition != undefined) {
            this._face_recognition = resource.face_recognition;
        }
        if (resource.bot_id != undefined) {
            this.bot_id = resource.bot_id;
        }
        if (resource.number_system != undefined) {
            this._currentSessionData.number_system = resource.number_system;
        }

        if (resource.extra_data != undefined) {
            try {
                for (let extra in resource.extra_data) {
                    this._currentSessionData.accountConfigValue[extra] = resource.extra_data[extra];
                }
            } catch (e) {
                console.error(e)
            }

        }

        var keysToCopy = [{ key: "accountWebsite", value: "account_website" }, { key: "webSiteName", value: "website_name" }, { key: "userGroup", value: "user_group" }, { key: "timeZoneAccount", value: "time_zone_account_name" }, { key: "timeZoneAccountCode", value: "time_zone_account" }, { key: "currencyAccount", value: "currency_account_name" }, { key: "currencyAccountCode", value: "currency_account" }, { key: "mobilePattern", value: "mobile_no_regex_account" }, { key: "pincodePattern", value: "pincode_no_regex_account" }, { key: "sessionTime", value: "session_creation_time" }, { key: "user_id", value: "user_id" }, { key: "account_id", value: "account_id" }, { key: "account_name", value: "account_name" }];
        for (let obj of keysToCopy) {
            this.setSpecificKeyFromMyConfigtoCurrentSession(resource, obj);
        }
        this._currentSessionData.configLoaded = true;
        this.setExcludedRolesPoweredBy(resource);
        this.setStreamSaver(resource.streamsaver);
        this.setEnv(resource.environment);

        try {
            if (this._currentSessionData[keysToCopy[0]["key"]] != undefined) {
                try {
                    this._currentSessionData[keysToCopy[0]["key"]] = this.buildDyanamicStr(this._currentSessionData[keysToCopy[0]["key"]], { id: this._currentSessionData["user_id"], identifier: this._currentSessionData["sessionTime"], token: this.btoa_utf8(this.encryptData(this._currentSessionData["user_id"])) })

                    const parsedUrl = new URL(this._currentSessionData[keysToCopy[0]["key"]]);
                    const params = parsedUrl.searchParams;
                    const websiteLabel = params.get("label");
                    if (websiteLabel) {
                        this._currentSessionData["accountWebsiteLabel"] = websiteLabel
                    }
                } catch (e) {

                }

            }
        } catch (e) {
            console.error(e)
        }
    }

    // Splits each white listed entry into its path and its query params then setWhitelisteUrls 
    parseWhiteListedUrls(whiteListedUrls) {
        var urls = [];
        var params = [];
        if (!Array.isArray(whiteListedUrls)) {
            return { urls: urls, params: params };
        }
        var currentUser = this.getCurrentUser() || {};

        if (whiteListedUrls.length > 0) {
            var urls = [];
            var objs = [];
            for (let index = 0; index < whiteListedUrls.length; index++) {
                const url = whiteListedUrls[index];
                var urlObj: any = this.getParameters(url, currentUser);
                urls.push(urlObj.url);
                objs.push(urlObj.params);
            }
            this.setWhitelisteUrls({ urls: urls, params: objs });
        } else {
            return { urls: urls, params: params };
        }
    }

    getParameters(url, userObj) {
        let urlString = url;
        var splitUrl = urlString.split('?');

        var obj = {};
        obj["url"] = urlString.split('?')[0];
        obj["url"] = this.buildDyanamicStr(obj["url"], userObj);
        obj["params"] = {}
        if (splitUrl.length > 1) {
            let queryString = new URLSearchParams(splitUrl[1]);
            for (let pair of queryString.entries()) {
                obj["params"][pair[0]] = this.buildDyanamicStr(pair[1], userObj);

            }
        }
        return obj;
    }

    setWhitelisteUrls(urls) {
        this._currentSessionData.whiteListedUrls = urls;
    }
    getWhitelisteUrls() {
        return (this._currentSessionData.whiteListedUrls != undefined) ? this._currentSessionData.whiteListedUrls : {};
    }
    setDefaultApp(defaultApp) {
        this._currentSessionData.defaultApp = defaultApp;
    }
    getDefaultApp() {
        return (this._currentSessionData.defaultApp != undefined) ? this._currentSessionData.defaultApp : (this._appData && this._appData.DEFAULT_APP != undefined) ? this._appData.DEFAULT_APP : "";
    }

    isWCAGEnabled() {
        return (this._currentSessionData.wcag_enabled != undefined) ? this._currentSessionData.wcag_enabled : false;
    }

    btoa_utf8(str) {
        return btoa(unescape(encodeURIComponent(str)));
    }

    setEncryptionKey(resource) {
        if (resource.extra_data && resource.extra_data.newres) {
            this._currentSessionData.encryptKey = resource.extra_data.newres;
        }
    }

    setSpecificKeyFromMyConfigtoCurrentSession(resource, obj: any) {
        this._currentSessionData[obj["key"]] = false;
        if (resource[obj["value"]] != undefined && resource[obj["value"]] != "") {
            this._currentSessionData[obj["key"]] = resource[obj["value"]];
        }
    }

    getCurrentUserGroup() {
        return this._currentSessionData.userGroup;
    }

    parseEula(resource) {
        if (resource && resource.length > 0) {
            this._currentSessionData.eulaList = resource;
        }
    }

    getEula() {
        return (this._currentSessionData.eulaList != undefined) ? this._currentSessionData.eulaList : false;
    }

    checkPRNenabled() {
        return this._currentSessionData.prn_enabled == undefined ? false : this._currentSessionData.prn_enabled
    }

    checkPermissionforPrn(conditions: any, _resource: any, _endResource: any) {
        let P_resource = [{ "resource": "patient", "action_name": "register_uhid" }]
        conditions.find(x => x.resource == _endResource) ? conditions.push(conditions.splice(conditions.indexOf(conditions.find(x => x.resource == _endResource)), 1)[0]) : "";
        this.checkPRNenabled() ? conditions : (conditions.find(x => x.resource == _resource) ? (conditions = P_resource) : conditions);
        return conditions
    }

    check_permssion_PRN(conditions: any, _key: any) {
        this.checkPRNenabled() ? (conditions.filter(x => x[_key] == true) ? conditions.splice(conditions.filter(x => x[_key] == true), conditions.filter(x => x[_key] == true).length) : conditions) : conditions;
        return conditions;
    }

    setLanguageList(languageList) {
        if (languageList && languageList.length) {
            this._currentSessionData.languageList = languageList;
        } else {
            this._currentSessionData.languageList = [{ languageCode: "en", languageName: "English" }];
        }
    }

    setSuperApps(superApps) {
        if (superApps && superApps.length) {
            this._currentSessionData.superApps = superApps;
        } else {
            this._currentSessionData.superApps = [];
        }
    }
    setAdConfig(adConfigs) {
        if (adConfigs && adConfigs.length) {
            this._currentSessionData.adConfigs = adConfigs;
            localStorage.setItem(this._currentKeys.adConfigs, JSON.stringify(adConfigs));
        } else {
            this._currentSessionData.adConfigs = [];
        }
    }

    removeAdConfig() {
        localStorage.removeItem(this._currentKeys.adConfigs);
    }

    setAppPackage(app_package) {
        this._currentSessionData['header']['app_package'] = app_package;
    }
    setExcludedRolesPoweredBy(config) {
        this._currentSessionData.rolesExcludedPoweredBy = [];
        if (config.rolesExcludedPoweredBy != undefined) {
            var arr = [];
            for (let role of config.rolesExcludedPoweredBy) {
                arr.push(role.id);
            }
            if (arr.length) {
                this._currentSessionData.rolesExcludedPoweredBy = arr;
                this._currentSessionData.header.rolesExcludedPoweredBy = arr;
                var show = this.showPoweredBy();
                if (!show) {
                    var styles = `
                        ._wf-pp-footertext.paddinginlogofordesktopview {
                            display: none !important;
                        }
                        ._wf-lp-logo-footer-main {
                            display: none !important;
                        }
                        ._wf-pp-footericon {
                            display: none;
                        }
                    `;
                    var styleSheet = document.createElement("style")
                    styleSheet.type = "text/css"
                    styleSheet.innerText = styles
                    document.head.appendChild(styleSheet);
                }

            }
        }
    }
    showPoweredBy() {
        var rolesExcludedPoweredBy = this._currentSessionData.header.rolesExcludedPoweredBy || this._currentSessionData.rolesExcludedPoweredBy;
        if (this.getRoles() && this.getRoles().role != undefined) {
            if (rolesExcludedPoweredBy.indexOf(this.getRoles().role) > -1) {
                return false;
            } else {
                return true;
            }
        } else {
            if (rolesExcludedPoweredBy) {
                return false
            } else {
                return true;
            }
        }
    }

    getLanguageList() {
        return (this._currentSessionData.languageList != undefined) ? this._currentSessionData.languageList : false;
    }

    getSuperApps() {
        return (this._currentSessionData.superApps != undefined) ? this._currentSessionData.superApps : false;
    }


    getAdConfigs() {
        var adConfigs = localStorage.getItem(this._currentKeys.adConfigs);
        if (adConfigs != null) {
            return JSON.parse(adConfigs);
        }
        return (this._currentSessionData.adConfigs != undefined && this._currentSessionData.adConfigs.length > 0) ? this._currentSessionData.adConfigs : [];
    }


    setMenuList(menuList) {
        var menuList = JSON.parse(JSON.stringify(menuList));
        /*************** DYNAMIC URL ************/
        if (menuList && menuList.length) {
            menuList = menuList.sort((a, b) => { return a.order - b.order });
            var user = this.getCurrentUser();
            for (let singleMenu of menuList) {
                if (singleMenu.url != undefined && singleMenu.url) {
                    singleMenu.url = this.buildDyanamicStr(singleMenu.url, user);
                }
                if (singleMenu.children != undefined && singleMenu.children.length > 0) {
                    singleMenu.children = singleMenu.children.sort((a, b) => { return a.order - b.order });
                    for (let singleMenuChild of singleMenu.children) {
                        if (singleMenuChild.url != undefined && singleMenuChild.url) {
                            singleMenuChild.url = this.buildDyanamicStr(singleMenuChild.url, user);
                        }
                        if (singleMenuChild.children != undefined && singleMenuChild.children.length > 0) {
                            singleMenuChild.children = singleMenuChild.children.sort((a, b) => { return a.order - b.order });
                            for (let singleMenuChildObj of singleMenuChild.children) {
                                if (singleMenuChildObj.url != undefined && singleMenuChildObj.url) {
                                    singleMenuChildObj.url = this.buildDyanamicStr(singleMenuChildObj.url, user);
                                }
                            }
                        }
                    }
                }
            }
        }
        /*************** DYNAMIC URL ************/

        this._currentSessionData.menuList = menuList;
    }
    getMenuList() {
        return this._currentSessionData.menuList;
    }

    buildDyanamicStr(str, data) {
        var finalStr = str;
        const regex = /\!!!(.*?)\!!!/gm;
        let m;
        while ((m = regex.exec(str)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            for (let match of m) {
                if (data != undefined && data[match] != undefined) {
                    finalStr = finalStr.replace('!!!' + match + '!!!', data[match]);
                }
            }
        }

        return finalStr
    }

    writeCookie(name, value, days:any="Session") {
        let expires = "";

        if (days && days !== "Session") {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = `; expires=${date.toUTCString()}`;
        }

        const isSecureContext = location.protocol === "https:";

        let cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;

        if (isSecureContext) {
            cookie += "; SameSite=None; Secure";
        } else {
            cookie += "; SameSite=Lax";
        }

        document.cookie = cookie;
    }
    readCookie(name) {
        var i, c, ca, nameEQ = name + "=";
        ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return false;
    }
    delete_cookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    getUserTimezone() {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {
            return "";
        }
    }

    addXsrfToken(data, login_required) {
        var encrypted = this.getXsrfToken(data, login_required);
        var headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
            .set('X-XSRF-TOKEN', encrypted)
            .set('timezone', this.getUserTimezone())
            .set('current_time', this.getCurrentTime())
            .set('current_url', this.Router.url)
            .set('host_name', window.location.host);
        return {
            headers: headers,
            responseType: 'text',
            observe: 'response' as 'response'
        }
    }
    addGetXsrfToken(data, login_required) {
        return this.addXsrfToken(decodeURIComponent(data), login_required);
    }

    getXsrfToken(data, login_required) {
        var key = this._currentSessionData.encryptKey;
        if (key && login_required) {
            return this.encryptText(key, CryptoJS.MD5(data).toString());
        } else {
            return CryptoJS.MD5(data).toString();
        }
    }

    encryptText(key, text) {
        var ivString = key.substring(0, 16);
        var parsedBase64Key = CryptoJS.enc.Utf8.parse(key);
        var encryptedData = CryptoJS.AES.encrypt(text, parsedBase64Key,
            {
                iv: CryptoJS.enc.Utf8.parse(ivString),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        return encryptedData.toString();
    }

    encryptData(text) {
        if (this._currentSessionData.encryptKey != undefined && this._currentSessionData.encryptKey) {
            var key = this._currentSessionData.encryptKey;
            var ivString = key.substring(0, 16);
            var parsedBase64Key = CryptoJS.enc.Utf8.parse(key);
            var encryptedData = CryptoJS.AES.encrypt(text, parsedBase64Key,
                {
                    iv: CryptoJS.enc.Utf8.parse(ivString),
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );
            return encryptedData.toString();
        }
        return text;
    }

    buildFactory(entryComponents) {
        for (let component of entryComponents) {
            if (component && component.ɵcmp != undefined && component.ɵcmp.selectors != undefined && component.ɵcmp.selectors.length) {
                this._factories["components"][component.ɵcmp.selectors[0]] = component;
            }
        }
    }
    sideBarOpen(val?) {
        setTimeout(() => {
            this.showSidebar = val != undefined ? val : !this.showSidebar;
        })
    }

    parseFaclityList(res) {

        var data = {};
        var dataAll = {};
        var dataAr = [];
        for (let index = 0; index < res.resource.length; index++) {
            var singleFacility = res.resource[index];
            dataAll[singleFacility.facility_id] = singleFacility;
            data[singleFacility.facility_id] = { name: singleFacility.name, primary_address: singleFacility.primary_address };
            let hasObj = {};
            hasObj['id'] = singleFacility.facility_id;
            hasObj['value'] = singleFacility.name;
            singleFacility.citizen_services != undefined ? hasObj['citizen_services'] = singleFacility.citizen_services : false;
            dataAr.push(hasObj);
        }

        this._currentSessionData.allFacilityList = dataAll;
        this._currentSessionData.facilityList = data;
        this._currentSessionData.facilityArray = dataAr;
        this._currentSessionData.facilityDetails = res;

    }

    parseAccountConfig(res) {
        if (res && res.multivalue != undefined) {
            for (let index = 0; index < res.multivalue.length; index++) {
                const single = res.multivalue[index];
                this._currentSessionData.accountConfig[single.id] = true;
                this._currentSessionData.accountConfigValue[single.id] = single.text;
            }
        } else if (res && res.editable_multivalue_value != undefined) {
            for (let index = 0; index < res.editable_multivalue_value.length; index++) {
                const single = res.editable_multivalue_value[index];
                this._currentSessionData.accountConfig[single.id] = true;
                this._currentSessionData.accountConfigValue[single.id] = single.text;
            }
        }
    }

    getAccountConfigValue(id) {
        return this._currentSessionData.accountConfigValue[id];
    }
    getAccountConfigValueList() {
        return this._currentSessionData.accountConfigValue;
    }
    getAccountConfig() {
        return this._currentSessionData.accountConfig;
    }

    getFacilityConfig(curFacilityID) {
        var accountConfig = {};
        var accountConfigValue = {};
        if (this._currentSessionData.allFacilityList && this._currentSessionData.allFacilityList[curFacilityID]) {

            var currObj = this._currentSessionData.allFacilityList[curFacilityID];
            if (currObj.tag_data != undefined && Array.isArray(currObj.tag_data) && currObj.tag_data.length > 0) {
                for (let index = 0; index < currObj.tag_data.length; index++) {
                    const element = currObj.tag_data[index];
                    accountConfig[element.key_name] = true;
                    accountConfigValue[element.key_name] = element.key_value_code;
                }
            }
        }
        return { config: accountConfig, configValue: accountConfigValue }
    }

    parseAsyncConfig(callback) {
        if (!this.isFacilityAware()) {
            //facilityscope
            if (this._currentSessionData?.orgList.length > 0) {
                var curFacilityID = this._currentSessionData.orgList[0].org_id;
                var result = this.getFacilityConfig(curFacilityID);
                this._currentSessionData.accountConfig = { ...this._currentSessionData.accountConfig, ...result.config };
                this._currentSessionData.accountConfigValue = { ...this._currentSessionData.accountConfigValue, ...result.configValue };
            }
        }

        if (this.checkNativeApp() && this._currentSessionData.qrLoginPassed != "" && this._currentSessionData.qrLoginPassed != "true") {
            this._currentSessionData.showqrLogin = true;
        }

        callback(this._currentSessionData.accountConfigValue)
    }

    setAccountWebsiteVisibilityPatient() {
        var accountConfig = this.getAccountConfig();
        this._currentSessionData.showAccountWebsite = false;
        if (accountConfig != undefined && accountConfig["show_web_link_patient"] != undefined && accountConfig["show_web_link_patient"]) {
            this._currentSessionData.showAccountWebsite = true;
        }
    }
    getAddressString(primaryAddress) {
        if (primaryAddress != undefined) {
            var str = "";
            if (primaryAddress.street1 != undefined && primaryAddress.street1 != '') {
                str += primaryAddress.street1;
            }
            if (primaryAddress.street2 != undefined && primaryAddress.street2 != '') {
                str += " " + primaryAddress.street2;
            }
            if (primaryAddress.cityDisplayName != undefined && primaryAddress.cityDisplayName != '') {
                str += ", " + primaryAddress.cityDisplayName;
            }
            if (primaryAddress.stateDisplayName != undefined && primaryAddress.stateDisplayName != '') {
                str += ", " + primaryAddress.stateDisplayName;
            }

            return str;
        }
        return "";
    }

    checkNativeApp() {
        var insidenative = this.readCookie("insidenative");
        return (!(insidenative == undefined || insidenative == false)) || (insidenative == "true");
    }

    getCurrentTime(): any {
        return new Date().getTime().toString();
    }

    setNotice(notice) {
        this._currentSessionData.noticeList = notice;
    }
    getNotice() {
        if (this._currentSessionData.noticeList != undefined) {
            return this._currentSessionData.noticeList;
        }
        return false;
    }

    getRtlLnCodes() {
        return [
            "ar"
        ];
    }
    isRTLLayout() {
        return (localStorage.getItem('appLanguage') != null && this.getRtlLnCodes().indexOf(localStorage.getItem('appLanguage')) > -1)
    }

    getArchiveConfigs() {
        return this._appData.ARCHIVE;
    }

    isNotHealth() {
        return this._appData.DEFAULT_APP != this._curApp;
    }

    getCurrentSupperAppObject() {
        if (this._currentSessionData.superApps && Array.isArray(this._currentSessionData.superApps) && this._currentSessionData.superApps.length > 0) {
            for (let index = 0; index < this._currentSessionData.superApps.length; index++) {
                const domainPlatform = this._currentSessionData.superApps[index];
                if (domainPlatform.key == this._curApp) {
                    return domainPlatform;
                    break;
                }
            }
        }
        return false;
    }

    // addWCAGEnabled(obj) {
    //     if (obj.wcag_enabled) {
    //         var d = document;
    //         var s = d.createElement("script"); s.setAttribute("data-language", localStorage.getItem("appLanguage"));
    //         s.setAttribute("data-mobile", "true");
    //         s.setAttribute("data-account", environment.wcag);
    //         s.setAttribute("src", "https://cdn.userway.org/widget.js");
    //         (d.body || d.head).appendChild(s);
    //         /* Hide UserWay accessibility icon on init */
    //         document.addEventListener('userway:init_completed', (event: any) => {
    //             var instance = event.detail.userWayInstance
    //             instance.iconVisibilityOff()
    //         })
    //     }
    // }

    public decryptText(key, encryptedCipherText) {
        if (key == '' || encryptedCipherText == '' || !encryptedCipherText || !key) {
            return encryptedCipherText;
        }
        try {
            var ivString = key.substring(0, 16);
            var parsedBase64Key = CryptoJS.enc.Utf8.parse(key);
            var decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
                iv: CryptoJS.enc.Utf8.parse(ivString),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return decryptedData.toString(CryptoJS.enc.Utf8);
        } catch (e) {
            console.debug("decryption error", encryptedCipherText);
            console.error(e);
            return encryptedCipherText;
        }

    }
    setDefaultLocation(baseService): void {
        let isStoreDeSelectManually = localStorage.getItem("deletedLocation");
        if (!isStoreDeSelectManually) {
            const currentLocationId = this.getCurrentLocation()?.location_id;
            // If no current location is set
            if (!currentLocationId) {
                const locations = this.getLocation();
                if (locations?.length) {
                    if (locations.length === 1) {
                        // Auto-select the only available location
                        // this.setCurrentLocation(locations[0]);
                        this.setLocationInSession(baseService, locations[0]);
                    } else {
                        // If multiple locations, find and set the default location
                        const defaultLocation = locations.find(location => location.is_default);

                        if (defaultLocation) {
                            this.setLocationInSession(baseService, defaultLocation)
                            //this.setCurrentLocation(defaultLocation);
                        }
                    }
                }
            }
        }
    }
    setLocationInSession(baseSer: BaseService, location) {
        let obj = { 'location_id': location.location_id, 'unset': false };
        if (baseSer && location && location.location_id) {
            baseSer.add(obj, 'change_location_event', true, this._appData.DEFAULT_APPLICATION).subscribe(
                (data: any) => {
                    if (data.errCode == 0 && data.resource.length > 0) {
                        this.setCurrentLocation(location);
                    }
                });
        }
    }
    checkAndroidTV() {
        var isandroidtv = this.readCookie("isandroidtv");
        return (!(isandroidtv == undefined || isandroidtv == false)) || (isandroidtv == "true");
    }

    /**
     * Safely get account_url from MAIN_ACCOUNT in localStorage
     *
     * @returns {string|null}
     */
    getAccountUrl() {
        try {
            const raw = localStorage.getItem("MAIN_ACCOUNT");

            if (raw && raw.trim() !== "") {
                const parsed = JSON.parse(raw);

                if (
                    parsed &&
                    typeof parsed === "object" &&
                    typeof parsed.account_url === "string" &&
                    parsed.account_url.trim() !== ""
                ) {
                    return parsed.account_url.trim();
                }
            }
        } catch (error) {
            console.error("Failed to parse MAIN_ACCOUNT:", error);
        }

        // Fallback
        return window.location.hostname;
    }
    setAuthenticationConfig(authenticationType, adConfigs) {
        this._currentSessionData.authenticationType = authenticationType;
        localStorage.setItem(this._currentKeys.authenticationType, authenticationType);
        this.setAdConfig(adConfigs);
    }

    getAuthenticationType() {
        return localStorage.getItem(this._currentKeys.authenticationType) || this._currentSessionData.authenticationType || "";
    }

    removeAuthenticationConfig() {
        this._currentSessionData.authenticationType = "";
        this._currentSessionData.adConfigs = [];
        localStorage.removeItem(this._currentKeys.authenticationType);
        this.removeAdConfig();
    }
}